import type * as React from "react";
import styled from "styled-components";
import { ShareBar, ShareBarValue, ShareBarChart, ShareBarChartBackground } from "@similarweb/ui-components";

const TrafficShareCellContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
`;
TrafficShareCellContainer.displayName = "TrafficShareCellContainer";

const Bar = styled.div`
    width: 100%;

    ${ShareBarValue} {
        width: 56px;
    }

    ${ShareBarChart} {
        height: 8px;
    }

    ${ShareBarChartBackground} {
        border-radius: 1px;
    }
`;

const noDataValue = "N/A";

interface IShareBarCellProps {
    value: number;
    fractionDigits?: number;
    hideValue?: boolean;
    children?: React.ReactNode;
}

//TODO: should add compare support
export const ShareBarCell = ({ value, fractionDigits = 2, children = null, hideValue = false }: IShareBarCellProps) => (
    <TrafficShareCellContainer>
        <Bar>
            <ShareBar
                value={value ?? noDataValue}
                hideChangeValue={true}
                hideValue={hideValue}
                fractionDigits={fractionDigits}
            />
        </Bar>
        {children}
    </TrafficShareCellContainer>
);

ShareBarCell.displayName = "ShareBar";
